module.exports = __webpack_public_path__ + "img/woman-plain.e823259f.svg";